import {Typography} from '@mui/material';
import {Stack} from '@mui/system';
import {IconIllustration, StyledCard} from 'presentation/components';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {formatText, getOnlyFirstWord} from 'presentation/utils';
import React from 'react';

const {responsibleWithouBenefitsCard} = translations['pt-br'].privateFlow.home;

export function ResponsibleWithoutBenefitsCard() {
	const {
		beneficiary: {nmSocialUsuarioC, nmUsuarioC},
	} = useAccountDataStore(store => store.accountData);
	const formattedBeneficiary = getOnlyFirstWord(formatText(nmSocialUsuarioC || nmUsuarioC));

	return (
		<StyledCard.Container
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'start',
				height: '100%',
			}}>
			<Stack flex={1}>
				<Typography variant="body2" component={'span'} color="text.primary">
					{formattedBeneficiary}, {responsibleWithouBenefitsCard}
				</Typography>
			</Stack>
			<IconIllustration variant="primary" size="small" customIconName="app-shortcut-filled" />
		</StyledCard.Container>
	);
}
